// src/app/app.module.ts

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Angular Material Modules
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion'; // Added for Expansion Panels
import { MatTooltipModule } from '@angular/material/tooltip'; // Ensure this is imported
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';

// Routing Module
import { AppRoutingModule } from './app-routing.module';

// Components
import { AppComponent } from './app.component';
import { AcceptInvitationComponent } from './components/accept-invitation/accept-invitation.component';
import { BorrowerDashboardComponent } from './components/borrower-dashboard/borrower-dashboard.component';
import { SupplierDashboardComponent } from './components/supplier-dashboard/supplier-dashboard.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { HomeComponent } from './components/home/home.component'; // Ensure HomeComponent exists
import { ThankYouComponent } from './components/thank-you/thank-you.component'; // Ensure correct path
import { PlaidLinkComponent } from './components/plaid-link/plaid-link.component';
import { TaxIdPipe } from "./pipes/tax-id/tax-id.pipe";
import { PersonalDetailsComponent } from "./components/personal-details/personal-details.component";
import { RequestCreditLineComponent } from './components/request-credit-line/request-credit-line.component';
import { PopulateFormDirective } from './directives/populate-form.directive'; // Import the directive
import { AboutBusinessComponent } from './components/about-business/about-business.component'; // Ensure correct path
import { BusinessStructureComponent } from './components/business-structure/business-structure.component';
import { BusinessLocationComponent } from './components/business-location/business-location.component';
import { OwnershipDisclosureComponent } from './components/ownership-disclosure/ownership-disclosure.component';
import { AdditionalOwnersComponent } from './components/additional-owners/additional-owners.component';
import { AdditionalOwnerInfoComponent } from './components/additional-owner-info/additional-owner-info.component';
import { AdditionalOwnerAddressComponent } from './components/additional-owner-address/additional-owner-address.component';
import { LinkBankAccountComponent } from './components/link-bank-account/link-bank-account.component';
import { CertificationsComponent } from './components/certifications/certifications.component';
import { ApplicationPendingComponent } from './components/application-pending/application-pending.component';
import { ApplicationDeniedComponent } from './components/application-denied/application-denied.component';
import { ApplicationApprovedComponent } from './components/application-approved/application-approved.component';
import { DateFormatDirective } from './directives/date-format.directive';

@NgModule({
  declarations: [
    AppComponent,
    AcceptInvitationComponent,
    PersonalDetailsComponent,
    RequestCreditLineComponent,
    BorrowerDashboardComponent,
    SupplierDashboardComponent,
    PageNotFoundComponent,
    HomeComponent,
    ThankYouComponent,
    PlaidLinkComponent,
    AboutBusinessComponent,
    BusinessStructureComponent,
    BusinessLocationComponent,
    OwnershipDisclosureComponent,
    AdditionalOwnersComponent,
    AdditionalOwnerInfoComponent,
    AdditionalOwnerAddressComponent,
    LinkBankAccountComponent,
    CertificationsComponent,
    ApplicationPendingComponent,
    ApplicationDeniedComponent,
    ApplicationApprovedComponent,
    DateFormatDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatExpansionModule,
    ReactiveFormsModule,
    SharedModule,
    MatCheckboxModule,
    MatDialogModule,
    FormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxCurrencyDirective,
    TaxIdPipe,
    MatDatepickerModule,
    MatNativeDateModule,
    PopulateFormDirective // Add the standalone directive here
],

  providers: [provideNgxMask()],
  bootstrap: [AppComponent]
})
export class AppModule { }
